export default {
    state: {
        token: localStorage.getItem('token') || '',
        userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}')
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
            localStorage.setItem('token', token);
        },
        SET_USER_INFO(state, userInfo) {
            state.userInfo = userInfo;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
        },
        CLEAR_USER_STATE(state) {
            state.token = '';
            state.userInfo = {};
            localStorage.removeItem('token');
            localStorage.removeItem('userInfo');
        }
    },
    actions: {
        // 登录
        login({ commit }, token) {
            commit('SET_TOKEN', token);
        },
        // 设置用户信息
        setUserInfo({ commit }, userInfo) {
            commit('SET_USER_INFO', userInfo);
        },
        // 登出
        logout({ commit }) {
            commit('CLEAR_USER_STATE');
        }
    }
} 
